import { useTranslation } from 'react-i18next'

import type { ResourceGroup } from '../data/oleshkyResources'
import EmbeddedVideo from './VideoPlayer/EmbeddedVideo'

// Article links grouped by outlet (bold outlet name, then its links with dates), for the Inform
// sections of the Help and left bank pages.
export function ResourceGroups({ groups }: { groups: ResourceGroup[] }) {
  const { t } = useTranslation()

  return (
    <>
      {groups.map(({ title, links, i18n, video }, i) => (
        <div key={i} className='flex flex-col gap-1'>
          <strong>{i18n ? t(title) : title}</strong>
          {video && <EmbeddedVideo video={video} title={i18n ? t(title) : title} />}
          {links.map(({ label, href, date }) => (
            <a
              key={href}
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 underline'
            >
              {i18n ? t(label) : label}
              {date && ` (${date})`}
            </a>
          ))}
        </div>
      ))}
    </>
  )
}
